import iConfig from "./iConfig";

const config: iConfig = {
  appId:  process.env.REACT_APP_CLIENT_ID!,
  esriApiKey: process.env.REACT_APP_ARCGIS_API_KEY!,
  reCaptchaKey: process.env.REACT_APP_CAPTCHA_KEY!,
  portalURL: process.env.REACT_APP_PORTAL_URL!,
  railcarStorage: {
    // webMapId: '7c0ec8d7318748bfafc13901fba56df9',
    webMapId: process.env.REACT_APP_RAILCAR_WEBMAP_ID!,
    contactFormId: process.env.REACT_APP_RAILCAR_CONTACT_FORM_ID!
  },
  transloading: {
    // webMapId: '1935596a32774b0aa84c46c2e25bdc3b',
    webMapId: process.env.REACT_APP_TRANSLOADING_WEBMAP_ID!,
    contactFormId: process.env.REACT_APP_TRANSLOADING_CONTACT_FORM_ID!
  },
  property: {
    webMapId: process.env.REACT_APP_PROPERTY_WEBMAP_ID!,
    contactFormId: process.env.REACT_APP_PROPERTY_CONTACT_FORM_ID!
  },
  contactUs: {
    formId: process.env.REACT_APP_CONTACT_US_FORM_ID!
  }
};

export default config;